import React from 'react';
import type { MapleDecoConfig } from '../../../shared/config/decorations';
import { MapleDeco, MapleDecoFixed } from './MenuPromoBackground.styles';

export function AnimatedMaple({ src, config }: { src: string; config: MapleDecoConfig }) {
  if (config.static) {
    return (
      <MapleDecoFixed
        src={src}
        alt=""
        loading="lazy"
        $left={config.left}
        $topPercent={config.topPercent}
        $width={config.width}
        $rotate={config.rotate}
        $zIndex={config.zIndex}
        $opacity={config.opacity}
      />
    );
  }

  return (
    <MapleDeco
      src={src}
      alt=""
      loading="lazy"
      $left={config.left}
      $topPercent={config.topPercent}
      $width={config.width}
      $rotate={config.rotate}
      $zIndex={config.zIndex}
      $duration={config.duration!}
      $ease={config.ease!}
      $delay={config.delay!}
      $windFromX={config.windFromX!}
      $windMidX={config.windMidX!}
      $windToX={config.windToX!}
      $windDropEnd={config.windDropEnd!}
      $opacity={config.opacity}
    />
  );
}
